import axios from 'axios';
import { resetUISlice, toggleLoadingAppOverlay, setLoggedOutFromTimeout, uiResetState } from 'reducers/ui/uiSlice';
import { resetCurrentUserSlice, currentUserResetState } from 'reducers/currentUser/currentUserSlice';
import { resetPaymentFormSlice, paymentFormResetState } from 'reducers/paymentForm/paymentFormSlice';
import { resetSettingsSlice, settingsResetState } from 'reducers/settingsSlice';
import { API_BASE_URL } from 'shared/constants/appConfig';
import { KEY_LOGIN_REDIRECT_URL } from 'shared/constants/common';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';
import { store } from '../reducers/store';

export const selfServiceApiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

const getUrlPathAndParams = (url) => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.pathname + parsedUrl.search;
  } catch (e) {
    return url;
  }
};

selfServiceApiClient.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger

    // handle 302 redirects in axios https://stackoverflow.com/questions/55926127/does-axios-have-the-ability-to-detect-redirects
    if (getUrlPathAndParams(response?.request?.responseURL) !== getUrlPathAndParams(response?.config?.url)) {
      window.location.href = response?.request?.responseURL;
    }
    return response;
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    const statusCode = error?.response?.status;

    if (
      statusCode === 401 &&
      !error?.response?.request?.responseURL?.includes?.('/self-service/login')
    ) {
      store.dispatch(setLoggedOutFromTimeout(true));
      store.dispatch(toggleLoadingAppOverlay(true));
      store.dispatch(resetUISlice());
      store.dispatch(resetCurrentUserSlice());
      store.dispatch(resetPaymentFormSlice());
      store.dispatch(resetSettingsSlice());

      // TODO: put in helper file and use in SignOutButton & SSOLoginFail if this works
      const checkReduxIsReset = () => {
        const state = store.getState();
      
        const filteredUIState = Object.fromEntries(
          Object.keys(uiResetState).map(key => [key, state.ui[key]])
        );
      
        if (
          JSON.stringify(filteredUIState) === JSON.stringify(uiResetState) &&
          JSON.stringify(state.currentUser) === JSON.stringify(currentUserResetState) &&
          JSON.stringify(state.paymentForm) === JSON.stringify(paymentFormResetState) &&
          JSON.stringify(state.settings) === JSON.stringify(settingsResetState)
        ) {
          localStorage.setItem(KEY_LOGIN_REDIRECT_URL, window.location.pathname);
          window.location.href = ROUTES_SELF_SERVICE.LOGIN;
        } else {
          requestAnimationFrame(checkReduxIsReset);
        }
      };      

      requestAnimationFrame(checkReduxIsReset);
    }

    return Promise.reject(error);
  }
);
